import React from 'react'
import style from './style.css'

export default props => {
    let { children, styleName, className, floating, height, ...other } = props

    return (
        <div
            {...other}
            className={`${style.scroll} ${props.floating ? style.floating : ''} ${props.className || ''} ${style[props.styleName || '']}`}
            style={{
                ...props.style,
                
                maxHeight: props.height || null,
            }}
            >
            {props.children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/BoxScroll/index.js